import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { map, tap } from 'rxjs/operators';
import { OfferHeader } from '../../../domain/offer.domain';
import { PolicyHeader } from '../../../domain/policy.model';
import { OfferFilter, PolicyFilter } from '../../../domain/registry.domain';
import { FileService } from '../service/file.service';
import { OfferService } from '../service/offer.service';
import { PolicyService } from '../service/policy.service';
import { RegistryAction } from './registry.action';

export class RegistryStateModel {
    offerFilter: OfferFilter;
    offers: OfferHeader[];

    policyFilter: PolicyFilter;
    policies: PolicyHeader[];
}

@State<RegistryStateModel>({
    name: 'registry',
    defaults: {
        offerFilter: new OfferFilter(),
        offers: null,

        policyFilter: new PolicyFilter(),
        policies: null,
    }
})
@Injectable()
export class RegistryState {

    constructor(private offerService: OfferService,
                private policyService: PolicyService,
                private fileService: FileService,
    ) {
    }

    @Selector()
    static getOfferFilter(state: RegistryStateModel) {
        return state.offerFilter;
    }

    @Selector()
    static getOffers(state: RegistryStateModel) {
        return state.offers;
    }

    @Selector()
    static getPolicyFilter(state: RegistryStateModel) {
        return state.policyFilter;
    }

    @Selector()
    static getPolicies(state: RegistryStateModel) {
        return state.policies;
    }

    @Action(RegistryAction.Clear)
    cleanOffers(context: StateContext<RegistryStateModel>) {
        context.patchState({
            offerFilter: new OfferFilter(),
            offers: null,
            policyFilter: new PolicyFilter(),
            policies: null,
        })
    }

    @Action(RegistryAction.GetOffers)
    getOffers(context: StateContext<RegistryStateModel>, action: RegistryAction.GetOffers) {
        return this.offerService.getAll(action.filter)
            .pipe(map(offers => {
                context.patchState({offerFilter: action.filter, offers})
            }));
    }

    @Action(RegistryAction.GetOffersCSV)
    getOffersCSV(context: StateContext<RegistryStateModel>, action: RegistryAction.GetOffersCSV) {
        return this.offerService.getAllCSV(action.filter)
            .pipe(tap(file => {
                this.fileService.getFileByToken(file.token);
            }));
    }

    @Action(RegistryAction.GetPolicies)
    getPolicies(context: StateContext<RegistryStateModel>, action: RegistryAction.GetPolicies) {
        return this.policyService.getAll(action.filter)
            .pipe(map(policies => {
                context.patchState({policyFilter: action.filter, policies})
            }));
    }

    @Action(RegistryAction.GetPoliciesCSV)
    getPoliciesCSV(context: StateContext<RegistryStateModel>, action: RegistryAction.GetPoliciesCSV) {
        return this.policyService.getAllCSV(action.filter)
            .pipe(tap(file => {
                this.fileService.getFileByToken(file.token);
            }));
    }
}
